import { computed, onBeforeMount } from 'vue';
import ApiClient from '@/ApiClient';
import { useStateComposable } from '@/state/composables';

const { computedState, state } = useStateComposable({
  switchAccounts: [],
  requested: false,
});

const accountNames = computed(() => state.switchAccounts.map(a => a.name));

// The endpoint excludes the active company, so a non-empty list means the admin
// has at least one other company to be confused with.
//
// Only honest for recognition-only admins once B2B-139 is deployed: before that
// /auth/switch/company was company-admin gated, so their list was always empty
// and could not be told apart from "one company".
const hasMultipleCompanies = computed(() => state.switchAccounts.length > 0);

// Whether to surface the active company to the user (B2B-54). Having another
// company to be confused with is the whole reason to name the current one, so
// this tracks hasMultipleCompanies; it stays a separate name because that is the
// question the recognition pages are asking.
const shouldShowCompanyIndicator = hasMultipleCompanies;

const getSwitchAccounts = async () => {
  state.requested = true;
  try {
    state.switchAccounts = (await ApiClient.getAuthSwitch())?.data || [];
  } catch (error) {
    // Degrade to "no other companies" rather than propagating: the switcher has
    // nothing to offer and the pill stays hidden.
    state.switchAccounts = [];
  }
};

export default () => {
  onBeforeMount(() => {
    // Shared across every consumer: AppPage used to re-fetch this on each page
    // mount, which is what the comment in ApiClient.getAuthSwitch refers to.
    if (!state.requested) {
      getSwitchAccounts();
    }
  });

  return {
    ...computedState,
    accountNames,
    hasMultipleCompanies,
    shouldShowCompanyIndicator,
  };
};
